import isUndefined from 'lodash/isUndefined';
import get from 'lodash/get';

/**
 * Creates a new InputTextAreaController.
 * @class
 * @extends InputController
 */
class InputTextAreaController {
    /**
     * @constructor
     * @param $ngRedux
     */
    constructor($ngRedux) {
        this.$ngRedux = $ngRedux;
        this.input = null;
    }

    $onInit() {
        if (this.validate && isUndefined(this.name))
            throw new Error('Missing textarea name attribute');
        if (isUndefined(this.identifier))
            throw new Error('Missing textarea ' + this.name + ' identifier attribute');


        if (isUndefined(this.rows))
            this.rows = 5;
        if (isUndefined(this.validate))
            this.validate = false;
        if (isUndefined(this.required))
            this.required = false;
        if (isUndefined(this.disabled))
            this.disabled = false;

        this.unsubscribeModule = this.$ngRedux.connect(this.mapModule, {})(this);
        this.unsubscribe = this.$ngRedux.connect(this.mapState.bind(this), {})(this);
    }

    onChange() {
        this.$ngRedux.dispatch({
            type: 'INPUT_TEXT_AREA_CHANGE',
            id: this.identifier,
            path: this.statePath,
            input: this.input
        });
    }

    $onDestroy() {
        this.unsubscribe();
        this.unsubscribeModule();
    }

    mapModule(state) {
        return {
            module: state.navigation.module
        };
    }

    mapState(state) {
        return {
            input: get(state[this.module],[this.identifier, this.statePath].join('.'))
        }
    }
}

InputTextAreaController.$inject = ['$ngRedux'];

export const inputTextArea = {
    bindings: {
        identifier: '@',
        statePath: '@',
        name: '@',
        label: '@',
        rows: '<',
        maxLength: '<',
        validate: '<',
        required: '<',
        disabled: '<'
    },
    require : {
        form : '^form'
    },
    controller: InputTextAreaController,
    template: `
        <md-input-container class="md-block" flex>
            <label>{{$ctrl.label}}</label>
            <textarea
                id="{{$ctrl.name}}"
                name="{{$ctrl.name}}"
                rows="{{$ctrl.rows}}"
                md-maxlength="$ctrl.maxLength"
                ng-model="$ctrl.input"
                ng-change="$ctrl.onChange()"
                ng-required="$ctrl.required"
                ng-disabled="$ctrl.disabled">
            </textarea>
            <div ng-if="$ctrl.validate" ng-messages="$ctrl.form[$ctrl.name].$error" ng-show="$ctrl.form.$submitted || $ctrl.form[$ctrl.name].$touched">
                <div ng-message="required">{{'COMMON.FIELD_REQUIRED' | translate}}</div>
            </div>
        </md-input-container>
    `
};
